$(document).on("turbolinks:load", () => {
  if ($("body").hasClass("messages") && $("body").hasClass("show")) {
    $(".deleteBtn").on("click", (e) => {
      return confirm("Supprimer ce message ?");
    });
  }
});
